import { FETCH_METHODS, SearchConfig } from "../api.model"
import { DataTableSchema, TableColumnSchema } from "../dynamic-data-table.model"
import { BrandDropdown, DefaultNumber, defaultSearchContainerButtons, EmpStatusDropdown, FieldNames, FirstNameText, LastNameText, SpinIdNumber } from "../form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig, Props } from "../form.model"
import { TenureAreaOptions, tenureAreaRegionField, TenureDefaultTableSchema, TenureTitle } from "../tenure.model";

export const TotalTenureInMonths ="Total Tenure"
const OEMTenureFilterField: FormFieldConfig = {
  ...structuredClone(DefaultNumber),
  fieldName: FieldNames['Tenure'],
  displayName: TotalTenureInMonths,
  camelCase:true,
  fieldCriteriaConfig: {
    operators: [
      { value: 'less than', label: 'Less than', title: 'Less Than' },
      { value: 'greater than', label: 'Greater than', title: 'Greater Than' },
      { value: 'equal to', label: 'Equal to', title: 'Equal to' }
    ],
    value: 'equal to'
  }
}
const FormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber, BrandDropdown,  {...structuredClone(tenureAreaRegionField),multiple:true, options:TenureAreaOptions}, FirstNameText, LastNameText, EmpStatusDropdown, OEMTenureFilterField
]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const OemTenureSchema = {
    [FieldNames['SpinId']]: 'spinId',
}

const columnSchema: Array<TableColumnSchema> = [
  { label: "SPIN ID", fieldKey: OemTenureSchema['spinId'] },
  { label: "FIRST NAME", fieldKey: 'firstName' },
  { label: "LAST NAME", fieldKey: 'lastName' },
  { label: "EMAIL", fieldKey: 'email' },
  { label: "EMPLOYEE STATUS", fieldKey: 'employeeStatus' },
  { label: "Brand", fieldKey: 'brand' },
  { label: "Brand Tenure", fieldKey: 'actualTenure', isCamelCaseHeader: true },
  { label: "Adjusted Tenure", fieldKey: 'adjustedTenure' , isCamelCaseHeader: true },
  { label: TotalTenureInMonths, fieldKey: 'totalTenure' , isCamelCaseHeader: true },
  { label: "Comments", fieldKey: 'comments' , isCamelCaseHeader: true },
  { label: "Attachments", fieldKey: 'attachment' , isCamelCaseHeader: true,fieldType:'file' }
]

export const OEMTenureDetailTableSchema: DataTableSchema = {
  ...structuredClone(TenureDefaultTableSchema),
  isSearchRequired:false,
  isExportRequired:false,
  isPaginationRequired:false,
  columnSchema: [
    { label: "FIRST NAME", fieldKey: 'firstName' },
    { label: "Start Date", fieldKey: 'startDate' },
    { label: "End Date", fieldKey: 'endDate' },
    { label: "Brand Tenure", fieldKey: 'brandTenure', isCamelCaseHeader: true },
    { label: "Adjusted OEM Tenure", fieldKey: 'adjustedTenure' , isCamelCaseHeader: true },
    { label: TotalTenureInMonths, fieldKey: 'totalTenure' , isCamelCaseHeader: true }
  ],
}

export const OEMTenureTitle = 'OEM Tenure'

export const OEMTenureSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "getOemTenure",
  body:{
    "type": "oem"
  }
}

export const OEMFileExportSearchConfig:SearchConfig = {
    method:FETCH_METHODS['Post'],
    path:'getSignedUrl',
    body:{
        bucketName:'',
        key: '',
        type: 'Download'
    }
}
export const OEMTenureFilterSchema: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  ButtonsArray: FormButtonArray,
  searchConfig: OEMTenureSearchConfig,
}

export const OEMTenureTableSchema: DataTableSchema = {
  ...structuredClone(TenureDefaultTableSchema),
  columnSchema: columnSchema,
  exportConfig: {
    fileName: 'OEM_Tenure',
    exportMessage:'OEM Tenure data'
  },
  breadcrums: [{ level: 1, name: TenureTitle }, { level: 2, name: OEMTenureTitle }]
}

export const note: Array<any> = [
    'Tenure displayed in Months'
]

export const OEMTenureProps: Props = {
  isBreadCrumbSection: true,
  optionExplanation: note,
}